/** Vue 添加实例对象  配置入口*/

import Vue from 'vue'

import ElementUI from 'element-ui'
import qs from 'qs'
import animate from 'animate.css'

// import echart from 'echart'
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI)
Vue.use(animate)

Vue.directive('drag', {
  //1.指令绑定到元素上回立刻执行bind函数，只执行一次
  //2.每个函数中第一个参数永远是el，表示绑定指令的元素，el参数是原生js对象
  //3.通过el.focus()是无法获取焦点的，因为只有插入DOM后才生效
  bind: function () { },
  //inserted表示一个元素，插入到DOM中会执行inserted函数，只触发一次
  inserted: function (el) {
    let isChrome = false
    var explorer = navigator.userAgent;
    //Chrome
    if (explorer.indexOf("Chrome") >= 0) {
      isChrome = true
    }
    el.onmousedown = function (e) {
      var disx = e.pageX - el.offsetLeft;
      var disy = e.pageY - el.offsetTop;
      document.onmousemove = function (e) {
        if (isChrome && window.event.which === 0) {
          document.onmousemove = null;
          return false
        }
        el.style.left = e.pageX - disx + 'px';
        el.style.top = e.pageY - disy + 'px';
      }
      document.onmouseup = function () {
        document.onmousemove = document.onmouseup = null;
      }
    }
  },
  //当VNode更新的时候会执行updated，可以触发多次
  updated: function () { }
})
// Vue.prototype._echart = echart
Vue.prototype.qs = qs
const userTypes = {
  0: 'admin',
  1: 'teacher',
  2: 'student'
}
Vue.directive('auth', {
  inserted: ((el, binding) => {
    if(!binding.value){
      return false
    }
    let { type } = JSON.parse(sessionStorage.getItem('userData'))
    let userTypeEmen =  userTypes[type] // 当前用户类型
    if(!binding.value.includes(userTypeEmen)){
      // 用户权限没有
      el.parentNode && el.parentNode.removeChild(el);
    }
  })
})
